function setMarkInterestDone(state, value) {
  state.markInterestDone = value;
}

function setNoInterestMarksLeft(state, value) {
  state.noInterestMarksLeft = value;
}

function setLastMarked(state, value) {
  state.lastMarked = value;
}

function addSuperLiked(state, propositionId) {
  const id = String(propositionId);
  if (!state.superLikedIds.includes(id)) {
    state.superLikedIds = [...state.superLikedIds, id];
  }
}

function removeSuperLiked(state, propositionId) {
  const id = String(propositionId);
  state.superLikedIds = state.superLikedIds.filter(x => x !== id);
}

// The set is per primary ad: cleared when the user switches ad in place.
function clearSuperLiked(state) {
  state.superLikedIds = [];
}

export default {
  setMarkInterestDone,
  setNoInterestMarksLeft,
  setLastMarked,
  addSuperLiked,
  removeSuperLiked,
  clearSuperLiked
};
